<template>
	<Layout>
	  	<!--Choose apetite-->
	  	<div class="container-sm" v-if="cuisines.length">
			<h4 class="apetite mt-3">Choose your apetite</h4>
		   <ul class="cuisines">
		   	<li  v-for="cuisine in cuisines" :key="cuisine.c_id">
		   		<div>
			   		<router-link :to="{ name: 'restaurants', params: {id: cuisine.c_id} }" >
			   			<div v-if="cuisine.image"  class="single-cuisine" :style="{ 'background-image': 'url(' + $image_url + cuisine.image + ')' }"></div>
			   			<div v-else  class="single-cuisine" :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
			   		</router-link>
						<p>{{ cuisine.name }}</p>
					</div>
		   	</li>
		   </ul>
		</div>
    
		<!--Carousel-->
	  	<div id="home-slider" class="carousel slide home-slider" data-bs-ride="false">
			<div class="container-sm">
				<div class="carousel-inner">
			  		<div class="carousel-item" v-for="(slider, index) in sliders" :key="slider.bn_id" v-bind:class="{ 'active': index==0 }">
				  		<img :src="$image_url + slider.image" class="w-100" alt="image"/>
				  	</div>
				</div>

				<div class="carousel-indicators">
    				<button type="button" data-bs-target="#home-slider" :data-bs-slide-to="index" v-for="(slider, index) in sliders" :key="slider.bn_id" v-bind:class="{ 'active': index==0 }" aria-current="true"></button>
  				</div>
			</div>
		</div>
	  	<br /><br /><br />
  
	  	<!--Breakfast-->
  
	  	<section>
			<div class="container my-3" v-if="sections.length">
		  		<div class="col" v-for="section in sections" :key="section.hs_id">
			  		<div class="container-sm" v-if="section.restaurants.length">
						<h3 style="text-align: center">{{ section.title }}</h3>
						<h5 class="breakfast">Top restaurants and cafes in Bahrain, based on trends</h5>
						<div class="row mx-auto my-auto justify-content-center mt-5 mb-5">

							<carousel class="container carousel" v-bind="options">
								<div v-for="(restaurant) in section.restaurants" :key="restaurant.r_id" class="flex carousel">
						   		<div class="card me-2 restaurant-card">
						  			<!-- <router-link :to="{ name: 'restaurant-details ',params: {id: restaurant.r_id,branch_id: restaurant.branch_id } }" > -->
						  			<a :href="'/restaurant-details/' + restaurant.r_id + '/' + restaurant.branch_id">
												<div v-if="restaurant.rest_image" class="restaurant-image"  :style="{ 'background-image': 'url(' + $image_url + restaurant.rest_image + ')' }">
													</div>
												<div v-else  class="restaurant-image" :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
										</a>
										<!-- </router-link> -->
						  				<div class="card-body">
											<div class="row">
							  					<div class="col">
													<h5 class="card-title">
															  {{ restaurant.rest_name }}
													</h5>
							  					</div>
							  					<div class="col-1 d-flex">
													<img src="/design/hungerline-images/food-delivery.png" style="width: 20px; height: 20px" />
							  					</div>
							  					<div class="col">						
														<p class="dtime">Within {{ restaurant.travel_time }} min</p>
															
							  					</div>
											</div>
											<p class="card-text restaurant-types"><span v-for="type in restaurant.types" :key="type.name">
							  							{{ type.name }}</span>
											</p>
											<div class="row ratings">
							 					<span v-if="restaurant.ratings >= 0 && restaurant.ratings < 1" > 
							 						<img src="/design/hungerline-images/happy.png" />Worst
							 					</span>
											  	<span v-if="restaurant.ratings>=1 && restaurant.ratings < 2"> 
											  		<img src="/design/hungerline-images/happy.png" />Bad
											  	</span> 
											  	<span v-if="restaurant.ratings>=2 && restaurant.ratings <3" > 
											  		<img src="/design/hungerline-images/happy.png" />Good
											  	</span> 
											  	<span v-if="restaurant.ratings>=3 && restaurant.ratings <4" > 
											  		<img src="/design/hungerline-images/happy.png" />Very Good
											  	</span>
											   <span v-if="restaurant.ratings>=4 && restaurant.ratings<=5 " > 
											   	<img src="/design/hungerline-images/happy.png" />Excellent
											   </span>
						   				</div>
						  				</div>
									</div>
								</div>

								<template slot="prev">
								   <span class="prev material-icons">arrow_back_ios</span>
								</template>

  								<template slot="next">
  									<span class="next material-icons">arrow_forward_ios</span>
  								</template>

							</carousel>

							<br /><br />
			  			</div>
					  	
					</div>
		  		</div>
			</div>
	  	</section>
  
	  	<br /><br /><br />
  
	 
	  	<br /><br />
	</Layout>
</template>
  
<script>
  // @ is an alias to /src
  import Layout from "@/layout/Main.vue";
  import carousel from 'vue-owl-carousel';
  import NoImageUrl from "@/assets/no-image.png";
  
  export default {
	   
	components: {
	  Layout,carousel 
	},
  
	data() {
	  	return {
			NoImageUrl, 
			sections: [],
			cuisines: [],
			location:[],
			restaurants: {},
			section: "",
			cuisine:{},
			image:'',
			data: [],
			  sliders:[],
			token: "",
			errors: {},
			name: "",
			rest_image: "",
			rest_name: "",
			publicPath: process.env.BASE_URL,

			style: null,
	    	options: {
	        	nav: false,
	        	dots: false,
	        	loop: true,
	        	// rewind: false,
	        	// rtl: true,
	        	autoplay: false,
	        	// autoplaySpeed: false,
	        	// smartSpeed: 3000,
	        	// autoplayTimeout: 3000,
	        	// autoplayHoverPause: true,
	        	//slideTransition: "linear",
	        	autoWidth: false,
	        	autoHeight: false,
	        	margin: 10,
	        	responsive: {
		        	0: {
		        		items:1, 
		        		nav:false
		        	},
		        	600: {
		        		items:1,
		        		nav:false
		        	}, 
		        	1000: {
		            items:4,            
		            nav:false
		         }
		      },
	      }, //options ends
	   };
	},
	created() {
	  //alert(this.publicPath);
  
	  this.style = document.createElement("link");
	  this.style.setAttribute("rel", "stylesheet");
	  this.style.setAttribute("href", "/design/home.css");
	  document.head.appendChild(this.style);
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},

	mounted() {
		this.fetchLocation();
	  	this.fetchHome();
	  	this.fetchSliders();
	},
	methods: {
	  
	  fetchHome() {
  
		  if(this.location){
		  console.log(this.location);
		  let url =
		  "home?&latitude=" +
		  this.location.latitude +
		  "&longitude=" +
		  this.location.longitude +
		  "&block_no=" +
		  this.location.block_no;
		  this.$axios
		  .get(url, {headers:{ Authorization: "Bearer " + this.token }})
		  .then((res) => {
			var responseData = res.data;
			console.log(responseData);
			this.sections = responseData.data;
			this.cuisines = responseData.cuisines;
			console.log(this.cuisines);
			console.log(this.sections);
		  })
		   .catch((error) => {
					if (error.response) {
					   if(error.response.status == 422) {               
						  if (error.response.data) {
							 this.errors = error.response.data.message;
						  } 
						  this.$swal("", error.response.statusText, "error");
						  
					   } else if(error.response.status == 500) {
						  this.$swal("", error.response.statusText, "error");
  
					   } else if(error.response.status == 401) {
						  this.$swal("", error.response.statusText, "error");
						  this.$router.push({ name: "login" });
						  
					   } else {
						  this.$swal("", "Something went wrong", "error");
					   }
					} else {
					   this.$swal("", error.message, "error");
					}
				 })
				 .finally(() => (this.loading = false));
		  }
		  
	  },
	  fetchSliders() {           
		  if(this.location){
		  console.log( this.location);
		let url ="sliders?&latitude=" +
		  this.location.latitude +
		  "&longitude=" +
		  this.location.longitude ;
		  this.$axios
		  .get(url)
  
			.then((res) => {
			var responseData = res.data;
			console.log(responseData);
			this.sliders = responseData.data;
			console.log(this.sliders);
  
		  })
		  .catch((error) => {
					if (error.response) {
					   if(error.response.status == 422) {               
						  if (error.response.data) {
							 this.errors = error.response.data.message;
						  } 
						  this.$swal("", error.response.statusText, "error");
						  
					   } else if(error.response.status == 500) {
						  this.$swal("", error.response.statusText, "error");
  
					   } else if(error.response.status == 401) {
						  this.$swal("", error.response.statusText, "error");
						  this.$router.push({ name: "login" });
						  
					   } else {
						  this.$swal("", "Something went wrong", "error");
					   }
					} else {
					   this.$swal("", error.message, "error");
					}
				 })
				 .finally(() => (this.loading = false));
	  }
		  },
	   
		  fetchLocation() {
  
			  if (localStorage.getItem('sigofood_location')) {
									  var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
					  this.latitude = sigofood_location.latitude;
			this.longitude = sigofood_location.longitude;
					  this.block_no = sigofood_location.block_no;
  
					  this.location = sigofood_location;
  
						  console.log(this.location);
  
  
			  } else {
				this.$router.push({ name: "location" });
			}
		  }, 
		  
		 
	},
  };
  </script>
  